import React from "react";
import { cn } from "../../../../../../utils/classnames";

const PriceDetailsCell = ({ details, title, highlight, bold }) => (
  <div className="tw:flex tw:flex-col tw:gap-[5px] tw:w-full">
    {title && (
      <div className={cn("tw:font-hanken-grotesk tw:text-[13px] tw:sm:text-[15px] tw:leading-[20px] tw:sm:leading-[22px] tw:text-[#282828]", bold ? "tw:font-bold" : "tw:font-normal")}>
        {title}
      </div>
    )}
    <div className="tw:flex tw:flex-col tw:gap-1">
      {details.map((item) => (
        <div
          key={item.label}
          className="tw:flex tw:flex-col tw:lg:flex-row tw:items-start tw:lg:items-center tw:justify-between tw:gap-0.5 tw:lg:gap-2"
        >
          <div
            className={cn(
              "tw:text-[11px] tw:sm:text-[13px] tw:leading-[16px] tw:sm:leading-[18.5px] tw:font-hanken-grotesk tw:break-all",
              item.type === "discount" ? "tw:text-[#EA4335]" : "tw:text-[#8d8d8d]"
            )}
          >
            {item.label}
          </div>

          {item.value && (
            <div
              className={cn(
                "tw:text-[12px] tw:sm:text-[15px] tw:leading-[18px] tw:sm:leading-[22px] tw:font-hanken-grotesk tw:whitespace-nowrap",
                bold && "tw:font-bold",
                item.type === "discount"
                  ? "tw:text-[#EA4335]"
                  : highlight
                    ? "tw:text-[#282828]"
                    : item.value === "-" || item.value === "0 JPY" || item.value === 0
                      ? "tw:text-[#8d8d8d]"
                      : "tw:text-[#282828]"
              )}
            >
              {item.value === "0 JPY" || item.value === 0 ? "-" : item.value}
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
);

export default PriceDetailsCell;
